import {
  Component,
  EventEmitter,
  HostListener,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../services/auth/auth.service';
import { BreadcrumbService } from '../../../../services/breadcrumb/breadcrumb.service';
import { UserChangePasswordFormComponent } from '../user-change-password/user-change-password-form.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  @ViewChild('passwordForm') passwordForm?: UserChangePasswordFormComponent;
  environment = environment;

  innerWidth = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  @Output() showSideMenu = new EventEmitter<boolean>();

  // isMobile$ = this.utilService.isMobile$;
  role$ = this.authService.roles$;
  roleLiteral$ = this.authService.roleLiterals$;
  // username$ = this.store$.select(AuthSelect.username);

  token$ = this.authService.token$;

  isStageEnvironment =
    window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
    window.location.href.indexOf('local') !== -1
      ? true
      : false;
  userMenuItems: MenuItem[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private readonly breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.userMenuItems = [
      {
        label: 'Αλλαγή κωδικού',
        icon: 'pi pi-key',
        command: () => {
          this.passwordForm?.show();
        },
      },
      {
        label: 'Έξοδος',
        icon: 'pi pi-sign-out',
        command: () => {
          this.authService.logout();
        },
      },
    ];
  }

  onUserButtonClick() {
    //this.router.navigate(['doctor/profile']);
  }

  getNameAndRole(): string {
    const data = this.token$.getValue();
    const name = data?.name ?? 'Unknown';
    const role = this.getRoleLiterals(data?.role);

    return `${name} - ${role}`;
  }

  getRoleLiterals(roles: string | string[] | undefined | null): string {
    // Handle undefined or null
    if (!roles) return 'Ν/Α';

    // Handle array case
    let roleArray: string[] = [];
    if (Array.isArray(roles)) {
      roleArray = roles;
    } else if (typeof roles === 'string') {
      // Handle string case - split by comma if it contains commas
      roleArray = roles.includes(',') ? roles.split(',').map(r => r.trim()) : [roles];
    } else {
      return 'Ν/Α';
    }

    if (roleArray.length === 0) return 'Ν/Α';

    // Get the first role for display
    const firstRole = roleArray[0].trim();

    switch (firstRole) {
      case 'Admin':
        return 'Διαχειριστής Συστήματος';
      case 'ResponsiblePharmacist':
        return 'Υπεύθυνος Φαρμακοποιός';
      case 'Pharmacist':
        return 'Φαρμακοποιός';
      case 'Employee':
        return 'Υπάλληλος Φαρμακίου';
      case 'Supplier':
        return 'Υποψήφιος Πάροχος';
      case 'Auditor':
        // return 'Ελεγκτής Διεύθυνσης Θαλασσαιμίας'; // Removed Auditor case
      default:
        return firstRole || 'Ν/Α';
    }
  }

  onLogoClick() {
    this.breadcrumbService.clear();
    this.router.navigate(['/home']);
  }
}
